import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Alert, GridLegacy as Grid } from '@mui/material';
import getBuildingStaging from '../../../redux/selectors/staging';

const ProcessingAlert = ({ loaded, points }) => {
  const taggerRunning = useMemo(
    () =>
      points
        .values()
        .every((p) => 'auto_tagger.point_type_preds' in p.data || p.device.protocol === 'modbus'),
    [points]
  );

  if (!loaded) return null;
  if (taggerRunning) return null;

  return (
    <Grid item xs={12}>
      <Alert severity="warning">
        Some confidence values are not yet available and will appear after our processing is
        complete.
      </Alert>
    </Grid>
  );
};

const mapStateToProps = (state, { buildingId }) => ({
  ...getBuildingStaging(state, buildingId),
  loaded: state.entities.staging.loaded[buildingId] ?? false,
});

export default connect(mapStateToProps)(ProcessingAlert);
